/**
 * Features Page
 * Product capabilities and competitive comparison
 */

import { ScreenshotsSection } from '@/components/sections/screenshots';
import { MultiCloudFlowSection } from '@/components/sections/multi-cloud-flow';
import { UseCasesSection } from '@/components/sections/use-cases';
import { ModelGridSection } from '@/components/sections/model-grid';
import { ComparisonSection } from '@/components/sections/comparison';
import { CtaSection } from '@/components/sections/cta';

export function FeaturesPage() {
  return (
    <>
      <div className="pt-24">
        <div className="max-w-7xl mx-auto px-4 py-16 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Product Features</h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Explore Naivana's powerful capabilities, supported models, and see how we compare to competitors.
          </p>
        </div>
      </div>
      <ScreenshotsSection />
      <MultiCloudFlowSection />
      <UseCasesSection />
      <ModelGridSection />
      <ComparisonSection />
      <CtaSection />
    </>
  );
}
